
class DrawingFile  {
    constructor(drawingObject) {
        this.type = drawingObject.extension;
        this.link = drawingObject.original;
        this.mediaId = drawingObject.MediaId;
        this.fileSize = Number(drawingObject.fileSize / 10000) + 'MB';
    }
}

class Drawing {
    constructor(drawingObject) {
        this.name = drawingObject.name;
        this.productUpc = drawingObject.productUpc;
        this.files = [];
        this.types = [];
        this.filters = drawingObject.filters;
        this.pdf = null;
        this.dwg = null;
        this.addFile(drawingObject);
    }
    addFile(obj) {
        const DF = new DrawingFile(obj)
        this.files.push(DF);
        if (obj.extension == 'pdf') {
            this.pdf = DF;
        }
        if (obj.extension == 'dwg') {
            this.dwg = DF;
        }
        this.setTypes(obj)
    }
    hasDWG() {
        return this.files.findIndex(file => {
            return file.type === 'dwg'
        }) >=0
    }
    hasPDF() {
        return this.files.findIndex(file => {
            return file.type === 'pdf'
        }) >=0
    }
    setTypes(obj) {
        const filterSubType = obj.filters.find((filter) => filter.name === 'Product Sub Type')
        let subTypeValues = filterSubType.value
        let currentFilterType;
        subTypeValues.forEach(stValue => {
            if (stValue.indexOf('N-12') === 0) {
                currentFilterType = 'N-12 Fittings'
            }
            else if (stValue.indexOf('HP') === 0) {
                currentFilterType = 'HP Fittings';
            } else {
                currentFilterType = 'Structure & Accessories';
            }
            this.types = Array.from(new Set(this.types.concat(currentFilterType)))
        });
    }
    hasType(type) {
        return this.types.includes(type);
    }
    matchesFilterType(type, value) {
        if (this.hasType(type)) {
            return this.filters.findIndex((el) => {
            return(el.value.indexOf(value) >= 0)
            }) >= 0
        } else {
            return false;
        }
    }
}

class DrawingFilter {
    constructor(type, values = []) {
        this.type = type;
        this.values = values;
        this.selected = '';
    }
    addFilterValues(values) {
        const tmpValues = new Set([...this.values].concat(values));
        this.values = Array.from(tmpValues)
        this.values.sort();
    }
    selectValue(value) {
        this.selected = value;
    }
}

class DrawingLookup {
    constructor(drawings) {
        this.drawings = [];
        this.filters = [];
        drawings.forEach((drawing, index) => {
            let foundIndex = this.drawings.findIndex((el) => {
                return el.name === drawing.name
            })
            if (foundIndex >= 0) {
                this.drawings[foundIndex].addFile(drawing);
            } else {
                this.addDrawing(drawing)
            }
            this.updateDrawingFilters(drawing);
        })
    }
    addDrawing(drawing) {
        this.drawings.push(new Drawing(drawing));
    }
   
    hasFilterCategory(category) {
        return this.filters.findIndex((filter) => {
            return filter.type === category
        }) >=0
    }

    updateDrawingFilters(drawing) {
        const filters = drawing.filters;
        const subTypeValues = filters.find(val => {
            return val.name === 'Product Sub Type'
        }).value;

        subTypeValues.forEach(stv => {
            let filterType = 'Structure & Accessories';
            if (stv.indexOf('N-12') === 0) {    
                filterType = 'N-12 Fittings'
            } else if (stv.indexOf('HP') === 0) {
                filterType = 'HP Fittings'
            }
            if(this.hasFilterCategory(filterType)) {
                this.addValuesToFilterType(filterType, [stv])
            } else {
                this.filters.push(new DrawingFilter(filterType, [stv]));
                
            }
            
        })
    }
    addValuesToFilterType(type, values) {
        const filterIndex = this.filters.findIndex(val => val.type === type)
        this.filters[filterIndex].addFilterValues(values);
    }
    findMatchingDrawingsByTerm(searchTerm) {
        console.log('lets find matches', searchTerm);
    }
    selectFilter(type, value) {
        this.filters.forEach(val => {
            val.selectValue('')
        })
        const filterIndex = this.filters.findIndex(val => val.type === type)
        this.filters[filterIndex].selectValue(value)
    }
    findMatchesByFilterType(type, value) {
        const matchedCollection = []
        this.selectFilter(type, value);
        this.drawings.forEach((drawing) => {
            if(drawing.matchesFilterType(type, value)) {
                matchedCollection.push(drawing);
            }
        })
        return matchedCollection;
    }
}

export default DrawingLookup;